import {
    Box,
    Divider,
} from '@mui/material';
import {
    DeleteButton,
    EditButton,
    ShowButton,
    useRecordContext,
    Button,
} from 'react-admin';
import {
    useCreatePath,
} from 'ra-core';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useLocation } from 'react-router';
import { showAsideSx } from '@/components/layout/showPageLayout';
import { ContractorOwner } from '@/types';

export const ContractorOwnerAside = ({ link = 'edit' }: { link?: 'edit' | 'show' }) => {
    const location = useLocation();
    const record = useRecordContext<ContractorOwner>();
    if (!record) return null;

    const createPath = useCreatePath();
    const stopPropagation = (e: any) => e.stopPropagation();

    return (
        <Box sx={showAsideSx}>
            {link !== 'edit' ? (
                <></>
            ) : (
                <>
                    <Box my={2}>
                        <Button
                            component={Link}
                            to={createPath({ resource: 'contractor_owners', type: 'list' })}
                            label={'Back'}
                            onClick={stopPropagation}>
                            <ArrowBackIcon />
                        </Button>
                    </Box>
                    <Divider />
                </>
            )}
            <Box my={2}>
                {link === 'edit' ? (
                    <EditButton label="Edit Contractor" />
                ) : (
                    <ShowButton label="Show Contractor" />
                )}
                <br/>
                <DeleteButton mutationMode="pessimistic" redirect={location.state?.from || undefined} />
            </Box>
        </Box>
    );
};
